import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
// import Timestamp from 'src/components/Time/Timestamp';
import UUID from 'src/components/UUID';

/**
 * Description
 * @param {object} props
 * @returns {any} - AdminUserShowPropertyUser component.
 */
function AdminUserShowPropertyUser(props) {
  if (!props) {
    return <tr><td aria-label="loading" colSpan={7}><Loading /></td></tr>;
  }

  const { propertyUser } = props;
  const {
    uuid, externalIdentifier, active, property,
  } = propertyUser;
  const {
    uuid: propertyId, title: propertyTitle, externalIdentifier: propertyExternalIdentifier,
    active: propertyActive,
  } = property;

  return (
    <tr key={`property-user-${uuid}`}>
      <th scope="row" className="text-right">
        <UUID uuid={uuid} url={`/admin/property-users/${uuid}`} />
      </th>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
      <td>{externalIdentifier}</td>
      <td colSpan={2}>
        <Link to={`/admin/properties/${propertyId}`}>
          <strong>{propertyTitle}</strong>
          <br />
        </Link>
        <UUID uuid={propertyId} />
      </td>
      <td>
        <BadgeActiveTimeRange active={propertyActive} />
      </td>
      <td>{propertyExternalIdentifier}</td>
    </tr>
  );
}

AdminUserShowPropertyUser.propTypes = {
  propertyUser: PropTypes.shape({
    uuid: PropTypes.string,
    externalIdentifier: PropTypes.string,
    active: PropTypes.shape({
      start: PropTypes.number,
      finish: PropTypes.number,
    }),
    property: PropTypes.shape({
      uuid: PropTypes.string,
      title: PropTypes.string,
      externalIdentifier: PropTypes.string,
      active: PropTypes.shape({
        start: PropTypes.number,
        finish: PropTypes.number,
      }),
    }),
  }),
};

AdminUserShowPropertyUser.defaultProps = {
  propertyUser: null,
};

export default AdminUserShowPropertyUser;
